export interface RepositoryOption {
  label: string;
  value: string;
  url: string;
}

const getRepositoryName = (repository: unknown): string => {
  if (typeof repository !== 'string') return '';

  const parts = repository.split('/');
  return parts[parts.length - 1] || repository;
};

const getRepositoryUrl = (
  repository: unknown,
  project: Record<string, unknown>,
): string => {
  if (typeof repository !== 'string') return '';

  const projectUrl = project.projecturl;
  const projectOrg = project.projectorg;
  const projectName = project.projectname;

  if (
    typeof projectUrl === 'string' &&
    typeof projectOrg === 'string' &&
    typeof projectName === 'string'
  ) {
    const urlPrefix = projectUrl.split(`${projectOrg}/`)[0];
    return `${urlPrefix}${projectOrg}/${encodeURIComponent(
      projectName,
    )}/_git/${getRepositoryName(repository)}`;
  }

  return repository;
};

export const getRepositoryOptions = (
  data: unknown,
  selectedService: string,
): RepositoryOption[] => {
  const options: RepositoryOption[] = [];
  const projects: Record<string, unknown>[] = [];
  const repositoryMappings: { repository: string; service: string }[] = [];

  const visit = (value: unknown): void => {
    if (Array.isArray(value)) {
      value.forEach(item => visit(item));
      return;
    }

    if (!value || typeof value !== 'object') return;

    const current = value as Record<string, unknown>;
    if (
      typeof current.projectorg === 'string' &&
      typeof current.projectname === 'string' &&
      typeof current.projecturl === 'string'
    ) {
      projects.push(current);
    }

    if (
      typeof current.datakey === 'string' &&
      current.datakey.toLowerCase() === 'repositoryconfig' &&
      typeof current.service === 'string' &&
      current.service.toLowerCase() === selectedService.toLowerCase() &&
      Array.isArray(current.data)
    ) {
      current.data.forEach(repository => {
        if (typeof repository === 'string') {
          repositoryMappings.push({
            repository,
            service: current.service as string,
          });
        }
      });
    }

    Object.values(current).forEach(nestedValue => visit(nestedValue));
  };

  visit(data);

  repositoryMappings.forEach(({ repository, service }) => {
    const [repositoryOrg, repositoryProject] = repository.split('/');
    const project = projects.find(
      candidate =>
        candidate.projectorg === repositoryOrg &&
        candidate.projectname === repositoryProject,
    );
    const label = getRepositoryName(repository);
    if (!label) return;

    options.push({
      label,
      value: label,
      url:
        service.toLowerCase() === 'ado'
          ? getRepositoryUrl(repository, project || {})
          : repository,
    });
  });

  return options.filter(
    (option, index, allOptions) =>
      allOptions.findIndex(item => item.value === option.value) === index,
  );
};
